import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PageHead from "../../ar_components/header";
import Overview from "../../ar_components/collections/overview/index";

import Repeater from "../../ar_components/page/repeater/group_companies";

import Contact from "../../ar_components/page/contact/GroupCompanies";
import TwoColomGreenBox from "../../ar_components/page/2colom_green_box/index";
import ThreeColomBox from "../../ar_components/page/3colom_box/index";

import "./page.css";

function Page() {
  const location = useLocation();
  const { from } = location.state;
  const { catSEND } = location.state;

  const [page, setPost] = React.useState();

  function replaceSpaceWithUnderscore(str) {
    return str.replaceAll(" ", "_");
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        "https://admin.arabian-industries.net/api/api/collections/entry/" +
          catSEND +
          `/` +
          from +
          "?token=8c25a7a0819fe42e3a0ddb3adc68b1",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
        }
      );
      await response.json().then(function (response) {
        setPost(response);
        //console.log(response);
      });
    };
    fetchData();
  }, [catSEND, from]);

  if (!page) return null;

  return (
    <React.Fragment>
      <PageHead
        propID={page._id}
        propTitle={page.title}
        propTitleAr={page.title_ar}
        propPageTitle={page.page_title}
        propPageTitleAr={page.page_title_ar}
        propImage_web={process.env.REACT_APP_IMG + page.image_web.path}
        propImage_tab={process.env.REACT_APP_IMG + page.image_tab.path}
        propImage_mobile={process.env.REACT_APP_IMG + page.image_mobile.path}
        propMenuImage={process.env.REACT_APP_IMG + page.image_menu.path}
        propContent={page.content}
        propContentAr={page.content_ar}
      />
      <div>
        {page.page_content && (
          <div>
            {page.page_content.map((item, index) => (
              <React.Fragment className="PageBody">
                <div className="PagerHolder" key={index}>
                  <div className="Left">
                    <h2>{item.value.Title}</h2>
                  </div>

                  <div
                    className="Right"
                    dangerouslySetInnerHTML={{
                      __html: item.value.Content,
                    }}
                  />
                </div>
                <div className="OverTitle">{item.value.Sub_Title}</div>
              </React.Fragment>
            ))}
          </div>
        )}

        {/*  */}
        {page.two_colom_green_box_title && (
          <TwoColomGreenBox propID={page._id} />
        )}
        {/*  */}

        {page.select_overview && (
          <React.Fragment>
            <Overview
              title={page.select_overview_title}
              cat={page.select_overview}
              propID={page._id}
            />
          </React.Fragment>
        )}
        {/*  */}
        {page.What_we_do_box && <Repeater propID={page._id} />}
        {/*  */}
        {page.box && <ThreeColomBox propID={page._id} />}
        {/*  */}
        {page.contact && <Contact propID={page._id} />}
        {/*  */}
      </div>
    </React.Fragment>
  );
}
export default Page;
